import { render } from "./EmployeeBanking.vue?vue&type=template&id=77056eb8"
import script from "./EmployeeBanking.vue?vue&type=script&lang=js"
export * from "./EmployeeBanking.vue?vue&type=script&lang=js"

import "./EmployeeBanking.vue?vue&type=style&index=0&id=77056eb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__